const waterTypes = {
  REGULAR: "regular",
  SPARKLING: "sparkling",
};

export default waterTypes;
